import { IsBoolean, ValidateNested } from "class-validator";
import { DrawConstant } from "../../constant/DrawConstant";
import { Type } from "class-transformer";
import { DrawCabinetFront } from "./DrawCabinetFront";
import { DrawCabinetShape } from "../shape/CabinetShapes/DrawCabinetShape";
import { DrawArticle } from "../DrawArticle";
import DrawS1CabinetShape from "../shape/CabinetShapes/DrawS1CabinetShape";
import { DrawS18CabinetShape } from "../shape/CabinetShapes/DrawS18CabinetShape";
import type { IDrawShape } from "../shape/IDrawShape";
import { DrawS20CabinetShape } from "../shape/CabinetShapes/DrawS20CabinetShape";
import { DrawS21CabinetShape } from "../shape/CabinetShapes/DrawS21CabinetShape";
import { DrawS27CabinetShape } from "../shape/CabinetShapes/DrawS27CabinetShape";
import { DrawS51CabinetShape } from "../shape/CabinetShapes/DrawS51CabinetShape";

export class DrawCabinet extends DrawArticle {
    @ValidateNested()
    @Type(() => DrawConstant)
    Constants!: DrawConstant;

    @ValidateNested({ each: true })
    @Type(() => DrawCabinetFront)
    Fronts!: DrawCabinetFront[];

    @Type(() => DrawCabinetShape, {
        keepDiscriminatorProperty: true,
        discriminator: {
            property: 'TypeName',
            subTypes: [
                { value: DrawS1CabinetShape, name: 'DrawS1CabinetShape' },
                { value: DrawS18CabinetShape, name: 'DrawS18CabinetShape' },
                { value: DrawS20CabinetShape, name: 'DrawS20CabinetShape' },
                { value: DrawS21CabinetShape, name: 'DrawS21CabinetShape' },
                { value: DrawS27CabinetShape, name: 'DrawS27CabinetShape' },
                { value: DrawS51CabinetShape, name: 'DrawS51CabinetShape' },
                // Add other subclasses here
            ],
        },
    })
    Shape?: IDrawShape;
    
    get CabinetShape(): DrawCabinetShape {
        return this.Shape as DrawCabinetShape;
    }

    @IsBoolean()
    IsTopOpen: boolean = false;
}